import React from 'react';
import useContext from '../../../../hooks/useContext';
import { TApiaComponent } from '../../../../types';

export interface IApiaComponentContext<TField = TApiaComponent> {
  field: TField;
  fieldId: string;
  name: string;
  onGrid: boolean;
}

export const ApiaComponentContextPrimitive = React.createContext<
  IApiaComponentContext | undefined
>(undefined);
ApiaComponentContextPrimitive.displayName = 'ApiaComponentContext';

const ApiaComponentContext = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: IApiaComponentContext;
}) => {
  return (
    <ApiaComponentContextPrimitive.Provider value={value}>
      {children}
    </ApiaComponentContextPrimitive.Provider>
  );
};

export function useApiaComponentContext<ContextType = TApiaComponent>() {
  const context = useContext(ApiaComponentContextPrimitive);

  return context as unknown as IApiaComponentContext<ContextType>;
}

export default ApiaComponentContext;
